import i18next, { TOptions, StringMap, TFunction } from 'i18next';

export type LangType = {
  [key: string]: { [key: string]: string };
};

export const NAMESPACE = 'shopfront';

export const DEFAULT_LANGUAGE = 'vi';

export const t = (
  keys: string | string[],
  options?: TOptions<StringMap>,
): string => {
  const text = i18next.t(keys, {
    ...options,
    ns: NAMESPACE,
    interpolation: { escapeValue: false },
  });
  return text || (keys as string);
};

export const loadLanguages = async (code?: string): Promise<LangType> => {
  const modules = await Promise.all<{ NAMESPACE: string; lang: LangType }>([
    import('@teko/ui-loyalty'),
    import('@teko/ui-order-detail'),
    import('@teko/terra-bff'),
    import('@teko/ui-user'),
    import('@teko/ui-cart'),
    import('@teko/cart'),
    import('@teko/order'),
    import('@teko/payment'),
    import('@teko/ui-payment'),
    import('@teko/ecommerce'),
    import('@teko/teko-ecommerce'),
    import('@teko/ds-desktop'),
    import('@teko/ds-mobile'),
    import('@teko/auth-react'),
    Promise.resolve({
      NAMESPACE,
      lang: {
        vi: (await import('./lang/vi.json')).default,
        en: (await import('./lang/en.json')).default,
      },
    }),
  ]);

  const resources: LangType = {};
  if (!code) {
    for (const mod of modules) {
      for (const langName of Object.keys(mod.lang)) {
        if (!resources[langName]) resources[langName] = {};
        resources[langName] = {
          ...resources[langName],
          [mod.NAMESPACE]: mod.lang[langName] as unknown as string,
        };
      }
    }
    return resources;
  }

  return {
    [code]: modules.reduce(
      (prev, curr) => ({ ...prev, [curr.NAMESPACE]: curr.lang[code] }),
      {},
    ),
  };
};

export const changeLanguage = async (lng: string): Promise<TFunction> => {
  return i18next.changeLanguage(lng);
};

export const initLanguage = async (
  resources: LangType,
  lng?: string,
): Promise<TFunction> => {
  return i18next.init({ lng, resources, initImmediate: false });
};
